/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LadderParticipant } from './LadderParticipant';
import {
    LadderParticipantFromJSON,
    LadderParticipantFromJSONTyped,
    LadderParticipantToJSON,
    LadderParticipantToJSONTyped,
} from './LadderParticipant';

/**
 * 
 * @export
 * @interface JoinLadderResponse
 */
export interface JoinLadderResponse {
    /**
     * 
     * @type {LadderParticipant}
     * @memberof JoinLadderResponse
     */
    participant: LadderParticipant;
}

/**
 * Check if a given object implements the JoinLadderResponse interface.
 */
export function instanceOfJoinLadderResponse(value: object): value is JoinLadderResponse {
    if (!('participant' in value) || value['participant'] === undefined) return false;
    return true;
}

export function JoinLadderResponseFromJSON(json: any): JoinLadderResponse {
    return JoinLadderResponseFromJSONTyped(json, false);
}

export function JoinLadderResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): JoinLadderResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'participant': LadderParticipantFromJSON(json['participant']),
    };
}

export function JoinLadderResponseToJSON(json: any): JoinLadderResponse {
    return JoinLadderResponseToJSONTyped(json, false);
}

export function JoinLadderResponseToJSONTyped(value?: JoinLadderResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'participant': LadderParticipantToJSON(value['participant']),
    };
}

